import { render, staticRenderFns } from "./credit-request-modal.vue?vue&type=template&id=636071dd&scoped=true&"
import script from "./credit-request-modal.vue?vue&type=script&lang=js&"
export * from "./credit-request-modal.vue?vue&type=script&lang=js&"
import style0 from "./credit-request-modal.vue?vue&type=style&index=0&id=636071dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636071dd",
  null
  
)

export default component.exports